import React from 'react'
import AboutBanner from '../components/AboutBanner'
import TeamChart from '../components/TeamChart'
import Testimonials from '../components/Testimonials'
const About = () => {
  return (
    <>
        <AboutBanner />
        <TeamChart />   
        <Testimonials />
    </>
  )
}

export default About